import { UseQueryResult, useQuery } from '@tanstack/react-query';
import { useContext } from 'react';
import ServicesContext from '../../global/services/ServicesContext';
import { DriveItem } from '../../Model/responseDtos/graph/DriveItem';
import { msGraphKeys } from './queryKeyFactory';

export function useGetDriveItemFromUrl(fileUrl?: string): UseQueryResult<DriveItem, unknown> {
  const servicesCtx = useContext(ServicesContext);

  const getDriveItem = () => {
    if (servicesCtx?.msGraphService && fileUrl) {
      return servicesCtx.msGraphService.getDriveItem(fileUrl);
    }
    throw new Error('Services context not initialized');
  };

  return useQuery({
    queryKey: msGraphKeys.getDriveItemFromUrl(fileUrl),
    queryFn: getDriveItem,
    retry: 0,
    staleTime: 180000,
    gcTime: 180000,
    enabled: !!fileUrl && (import.meta.env.VITE_ENV === 'QA' || import.meta.env.VITE_ENV === 'PROD')
  });
}
